// Websockets

import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_WEBSOCKETS_KEY,
    wsHost: process.env.MIX_WEBSOCKETS_HOST,
    wsPort: process.env.MIX_WEBSOCKETS_PORT,
    wssPort: process.env.MIX_WEBSOCKETS_PORT,
    forceTLS: process.env.MIX_APP_ENV !== 'local',
    activityTimeout: 120000,
    pongTimeout: 10000,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
});

// Tooltips

import tippy from 'tippy.js/dist/tippy-bundle.umd';
window.tippy = tippy;
